import { getField } from 'vuex-map-fields'

export default {
  metricGroups: (state) => {
    return state.metricGroups
  },
  getField
}
